<template>
  <div class="navMenu">
<!--    <el-menu-->
<!--      :default-openeds="['monitoringData']"-->
<!--    >-->
    <template v-for="(navMenu, index) in navMenus">
      <!-- 最后一级菜单 -->
      <el-menu-item v-if="!navMenu.children&&navMenu.entity"
                    :key="index" :data="navMenu" :index="navMenu.entity.name"
                    @click="goPage(navMenu.entity)"
      >
        <base-icon :iconClass="navMenu.entity.icon"></base-icon>
        <span slot="title">{{ navMenu.entity.isI18n?navMenu.entity.name:$t(`router.${navMenu.entity.name}`) }}</span>
      </el-menu-item>

      <!-- 此菜单下还有子菜单 -->
      <el-submenu v-if="navMenu.children&&navMenu.entity&&navMenu.entity.dfOpen"
                  :key="index" :data="navMenu" :index="navMenu.entity.name"
                  @click="goPage(navMenu.entity)"
      >
        <template slot="title">
          <base-icon :iconClass="navMenu.entity.icon"></base-icon>
          <span> {{ navMenu.entity.isI18n?navMenu.entity.name:$t(`router.${navMenu.entity.name}`) }}</span>
        </template>
        <!-- 递归 -->
        <NavMenu :navMenus="navMenu.children"></NavMenu>
      </el-submenu>
      <el-submenu v-else-if="navMenu.children&&navMenu.entity"
                  :key="index" :data="navMenu" :index="navMenu.entity.name"
                  @click="goPage(navMenu.entity)"
      >
        <template slot="title">
          <base-icon :iconClass="navMenu.entity.icon"></base-icon>
          <span> {{ navMenu.entity.isI18n?navMenu.entity.name:$t(`router.${navMenu.entity.name}`) }}</span>
        </template>
        <!-- 递归 -->
        <NavMenu :navMenus="navMenu.children"></NavMenu>
      </el-submenu>
    </template>
<!--    </el-menu>-->
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';

export default {
  name: 'NavMenu',
  props: ['navMenus'],
  data() {
    return {
    };
  },
  created() {
    //console.log('function11',this.navMenus);
  },

  methods: {
    ...mapActions(['setCollapse']),
    ...mapMutations('project', ['SET_CURRENT_PROJECT']),
    toggleCollapse() {
      this.setCollapse({ isCollapse: !this.getMenuCollapse });
      setTimeout(() => {
        this.$bus.$emit('RESIZE_WINDOW');
      }, 50);
    },
    goPage(item) {
      if (item.type === 'function') {

        this.SET_CURRENT_PROJECT(item.project);
        // 发布项目发生改变的广播
        this.$bus.$emit('UPDATE_PROJECT', item.project.id);
        if (this.$route.meta && this.$route.meta.attachProject) {
          this.$router.replace({ path: this.$route.path });
          return;
        }
      }
      this.$router.push(item.path);
    },
  },
};
</script>

